<template lang="html">

  <section class="dashboard-home column-center" :style="styles.backgroundWhite">

    <div class="contenedor-accesos row-center ais" :style="styles.colorWhite">


      <template v-if="totales">

      <div class="contenedor-acceso" v-if="totales.numPracticasPendienteValidar != 0">
        <router-link :to="$t('enlaces.validaciones')+'/pendientes'" class="acceso-el column-center" :style="ownstyle.acceso" >
          <span class="numero">{{totales.numPracticasPendienteValidar}}</span>
          <span class="titulo">{{(!!brand.dashboardtexts.validacion) ?  brand.dashboardtexts.validacion : $t('home.practicas_pendientes_validacion')}}</span>
        </router-link>
      </div>

      <div class="contenedor-acceso" v-if="totales.numOfertasConTitulacionesPendientesDeAprobar != 0">
        <router-link :to="$t('enlaces.aprobacionesdirector')+'/pendientes'" class="acceso-el column-center" :style="ownstyle.acceso" >
          <span class="numero">{{totales.numOfertasConTitulacionesPendientesDeAprobar}}</span>
          <span class="titulo">{{$t('home.ofertas_pendientes_validacion')}}</span>
        </router-link>
      </div>
      
      <div class="contenedor-acceso" v-if="totales.numPracticasPendienteEvaluacion != 0">
        <router-link  :to="$t('enlaces.tutorados')+'/en-evaluacion'"  class="acceso-el column-center" :style="ownstyle.acceso">
          <span class="numero">{{totales.numPracticasPendienteEvaluacion}}</span>
          <span class="titulo">{{$t('home.practicas_pendientes_cierre')}}</span>
        </router-link>
      </div>

      <div class="contenedor-acceso" v-if="totales.numTutorados != 0 || totales.numTutoradosOevaluacionAsignadas != 0">

        <router-link :to="$t('enlaces.tutorados')" class="acceso-el column-center" :style="ownstyle.acceso">
          <span class="numero" v-if="!!!brand.numTutoradosOevaluacionAsignadas">{{totales.numTutorados}}</span>
          <span class="numero" v-if="!!brand.numTutoradosOevaluacionAsignadas">{{totales.numTutoradosOevaluacionAsignadas}}</span>
          <span class="titulo">{{$t('home.tutorados')}}</span>
        </router-link>

      </div>

      </template>

      <div class="contenedor-favoritos row-start" :style="styles.colorBasic" v-if="favoritos.length > 0">

        <h2>{{$t('home.favoritos')}}</h2>

        <template v-for="(fav,key) in favoritos">

          <home-fav-el :fav="fav"></home-fav-el>

       </template>

     </div>

     <comunicaciones v-if="brand.hasComunicaciones"></comunicaciones>
     <popup-encuestas-obligatorias v-if="brand.hasEncuestas"></popup-encuestas-obligatorias>


   </div>





 </section>

</template>

<script lang="js">

  import {mapGetters, mapActions} from 'vuex';

  import homeFavEl from '@/components/parts/home-fav-el';

  import comunicaciones from '@/components/parts/comunicaciones';
  import encuestas from '@/components/parts/encuestas';
  import popupencuestas from '@/components/parts/popup-encuestas-obligatorias';

  export default  {
    name: 'dashboard-home',
    mounted(){
      if(!!this.isLogged){
        this.requestTotales();
      }
    },
    computed : {
      ...mapGetters({
        styles : 'getStyles',
        totales : 'getTotales',
        favoritos : 'getFavoritos',
        colors : 'basicColors',
        isLogged : 'getLogged',
        brand : 'getBrand'
      }),
      ownstyle : function(){
        return {
          acceso : {
            // background : (!!!this.colors.basicAlternative) ? this.colors.basic : this.colors.basicAlternative,
            // color : (!!!this.colors.fontAlternative) ? this.colors.white : this.colors.fontAlternative,
            background : '#e9eae7',
            color : '#000000'
          }
        }
      }
    },
    components : {
      'home-fav-el' : homeFavEl,
      'comunicaciones' : comunicaciones,
      'encuestas' : encuestas,
      'popup-encuestas-obligatorias' : popupencuestas
    },
    methods : {
      ...mapActions(['requestTotales'])
    }
  }
</script>

<style scoped lang="scss">
  .dashboard-home {
    width: 100%;
    height: 100%;
    justify-content: flex-start;
    padding: 50px 0;
    max-height: calc(100vh - 85px);
    overflow: scroll;
  }

  .title-seccion{
    text-align: center;
    font-size: 36px;
  }

  .contenedor-accesos{
    width: 100%;
    padding: 25px;
    max-width: 1200px;
  }

  .contenedor-acceso{
    width: 33.333333%;
    padding: 10px;
    text-align: center;
  }
  
  .acceso-el{
    width: 100%;
    padding: 25px;
    max-width: 300px;
    min-width: 100px;
    margin: 0 auto;
    height: 100%;
    justify-content: flex-start;
    -webkit-justify-content: flex-start;
    cursor: pointer;

    span{
      color: currentColor;
    }

    .numero{
      width: 100%;
      display: inline-block;
      font-size: 40px;
      text-align: center;
      color: currentColor;
       cursor: pointer;
    }

    .titulo{
      font-size: 20px;
      max-width: 200px;
      font-weight: 300;
       cursor: pointer;
    }
  }

  .contenedor-favoritos{
    width: 100%;
    margin-top: 50px;
    
    h2{
      font-weight: 800;
      width: 100%;
      display: inline-block;
      text-align: left;
      margin-bottom: 20px;
      padding: 0 50px;
    }

  }

  @media screen and (max-width: 900px){
    .contenedor-accesos{
      padding: 0px;
      padding-top: 10px;
    }
    .contenedor-acceso{
      width: 100%;
      padding-bottom: 0;
    }
    .acceso-el{
      max-width: 100%;
    }

    .dashboard-home{
      padding-top: 0;
      padding-bottom: 0;
    }

    .contenedor-favoritos{
      margin-top: 25px;
      h2{
        padding: 0 10px;
        text-align: center;
      }
    }
  }

  @media screen and (max-width: 600px){
    .acceso-el{
      padding: 10px;
      margin-bottom: 10px;
      -webkit-flex-direction: row;
      -moz-flex-direction: row;
      -ms-flex-direction: row;
      -o-flex-direction: row;
      flex-direction: row;
      justify-content: flex-start;
      -webkit-justify-content: flex-start;

      .numero{
        width: auto;
        text-align: center;
        padding-right: 20px;
        min-width: 70px;
      }

      .titulo{
        width: 100%;
        text-align: left;
      }
    }


    .contenedor-favoritos{
      h2{
        margin-bottom: 10px;
      }
    }


  }

</style>



// WEBPACK FOOTER //
// src/components/views/dashboard-home.vue